import { Component } from 'react';
import { FallbackProps } from './fallback';
import { logErrorToSentry } from '@utils/common';
import { newRelicUtils } from '@utils/newrelic';

const { sendError, isInitialized } = newRelicUtils;

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback: React.FC<FallbackProps>;
}
interface ErrorBoundaryState {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.setErrorState = this.setErrorState.bind(this);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Once we integrate sentry we can log the error to sentry
    logErrorToSentry({ error, extraInfo: errorInfo });
    // // Once we integrate new relic we can log the error to new relic
    if (isInitialized()) {
      sendError(error, errorInfo);
    }
  }
  setErrorState() {
    this.setState({ hasError: false });
  }

  render() {
    if (this.state.hasError) {
      // fallback UI
      const FallbackComponent = this.props.fallback;
      return (
        <FallbackComponent
          hasError={this.state.hasError}
          resetErrorState={this.setErrorState}
        />
      );
    }

    return this.props.children;
  }
}
